export default "__VITE_ASSET__586a23d9__"